import type { IFiatDropDownOption } from 'BreetComponents';
import { CURRENCIES, type CURRENCYCODETYPE, type IUseFormData } from 'BreetHelpers';
import type { Dispatch, SetStateAction } from 'react';
import * as yup from 'yup';

export type CURRENCYCONVERTERSTAGESTYPE = 'convert-currency' | 'transaction-details';

export const buyCryptoStageTitle: Record<CURRENCYCONVERTERSTAGESTYPE, string> = {
	'convert-currency': 'Currency Conversion',
	'transaction-details': 'Currency Conversion Details',
};

export const tabs = ['USD Wallet', 'Naira Wallet', 'GHS Wallet'] as const;

export type TABTYPE = (typeof tabs)[number];

const currencyValidation = yup
	.mixed<CURRENCYCODETYPE>()
	.oneOf(CURRENCIES, 'Invalid currency selected')
	.required('Currency is required');

export const CurrencyConverterSchema = yup.object({
	amount: yup
		.string()
		.required('Amount is required')
		.test('not-zero', 'Amount is required', (value) => value !== '0'),
	toAmount: yup
		.string()
		.required('Amount is required')
		.test('not-zero', 'Amount is required', (value) => value !== '0'),
	fromCurrency: currencyValidation,
	toCurrency: currencyValidation,
});

export type CurrencyConverterSchemaType = yup.InferType<typeof CurrencyConverterSchema>;

export interface ICurrencyConverterContext {
	formDataContextProps: IUseFormData<typeof CurrencyConverterSchema>;
	setFromSelectedFiatOption: Dispatch<SetStateAction<IFiatDropDownOption | undefined>>;
	setToSelectedFiatOption: Dispatch<SetStateAction<IFiatDropDownOption | undefined>>;
	fromSelectedFiatOption?: IFiatDropDownOption;
	toSelectedFiatOption?: IFiatDropDownOption;
}

export const getCurrencyFromLabel = (label: string): CURRENCYCODETYPE => {
	if (label.includes('USD')) return 'USD';
	if (label.includes('NGN')) return 'NGN';
	return 'GHS';
};
